import { useSendbird } from '@sendbird/uikit-react';
import ConnectionHandler from '@sendbird/uikit-react/handlers/ConnectionHandler';
import { useEffect } from 'react';

const CustomConnectionHandler = () => {
  const {
    state: { stores },
  } = useSendbird();
  const sdk = stores?.sdkStore?.sdk;

  useEffect(() => {
    try {
      const handler = new ConnectionHandler({
        onDisconnected() {
          console.log('onDisconnected');
          // Optionally, update UI to inform the user
        },
        onReconnectStarted() {
          console.log('onReconnectStarted');
          // Optionally, update UI to inform the user
        },
        onReconnectSucceeded() {
          console.log('onReconnectSucceeded');
          // Optionally, update UI to inform the user
        },
        onReconnectFailed() {
          console.log('onReconnectFailed');
          // Optionally, update UI to inform the user
        },
      });

      if (typeof sdk?.addConnectionHandler === 'function') {
        sdk.addConnectionHandler('UNIQUE_HANDLER_ID', handler);
      }
    } catch {
      console.error('Something went wrong with the connectionHandler registration');
    }

    // Clean up the connection handler when the component unmounts
    return () => {
      try {
        sdk.removeConnectionHandler('UNIQUE_HANDLER_ID');
      } catch {
        console.error('Failed to remove the connectionHandler');
      }
    };
  }, [sdk]);

  return null;
};

export default CustomConnectionHandler;
